module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.d228596.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module id = 885
// module chunks = 3